import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['EVENT_TYPE_LIST', 'EXPORTS_STATUS', 'PROFILE_EVENT_TYPE_LIST'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchEventTypesPolicy: build.query({
      query: (params = {}) => ({
        url: '/api/event_types/policy',
        params,
        validateStatus: (response) => (['200', '404'].includes(`${response}`))
      })
    })
  })
})

export const { useFetchEventTypesPolicyQuery } = api
